import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import PropTypes from "prop-types"
import React from "react"
import "./section-split-content-list-v2.scss"

const SectionSplitContentListV2 = ({ callsToAction, subSections }) => {
  return (
    <div className="section-split-content-list-v2">
      <div className="container-v2">
        {subSections && subSections.length > 0 && (
          <div className="section-split-content-list-v2--sub-sections">
            {subSections.map(subSection => (
              <div
                className="section-split-content-list-v2--sub-section"
                id={subSection.anchor}
                key={subSection.id}
              >
                <div className="section-split-content-list-v2--sub-section-content-wrapper">
                  <h3 className="section-split-content-list-v2--sub-section-title">
                    {subSection.title}
                  </h3>
                  {subSection.subTitle && (
                    <h4 className="section-split-content-list-v2--sub-section-sub-title">
                      {subSection.subTitle}
                    </h4>
                  )}
                  <p className="section-split-content-list-v2--sub-section-text">
                    {subSection.text?.childrenMarkdownRemark?.[0]?.html && (
                      <div
                        className="section-split-content-list-v2--sub-section-text-content"
                        dangerouslySetInnerHTML={{
                          __html:
                            subSection.text.childrenMarkdownRemark[0].html,
                        }}
                      />
                    )}
                  </p>
                </div>
                {subSection?.image?.fluid && (
                  <div className="section-split-content-list-v2--sub-section-image-wrapper">
                    {subSection.icon?.file?.url && (
                      <div className="section-split-content-list-v2--sub-section-icon-wrapper">
                        <img
                          alt={subSection.icon?.title}
                          src={subSection?.icon?.file?.url}
                        />
                      </div>
                    )}
                    <Image
                      image={subSection?.image?.fluid}
                      title={subSection.image?.title}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        {callsToAction && callsToAction.length > 0 && (
          <div className="section-split-content-list-v2--calls-to-action">
            {callsToAction.map(callToAction => (
              <ButtonV2
                accessibilityLabel={callToAction.accessibilityLabel}
                className={getButtonClasses(
                  callToAction.buttonStyle,
                  callToAction.buttonSize
                )}
                href={callToAction.path}
                key={callToAction.id}
                showArrow={callToAction.showArrow === "Yes" ? true : false}
                text={callToAction.text}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default SectionSplitContentListV2

SectionSplitContentListV2.propTypes = {
  callsToAction: PropTypes.array.isRequired,
  subSections: PropTypes.array.isRequired,
}
